/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { useRecoilState } from "recoil";
import { useRecoilValue } from "recoil";
import "react-reflex/styles.css";

import layoutConf from "../../config/layoutConf";

import getSchema from "../../lib/api/getSchema";
import authProfileState from "../../states/authProfileState";
import notificationState from "../../states/notificationState";

import SaveToExcelButton from "../input/SaveToExcelButton";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import MomSysDeliveryDetail from "./MomSysDeliveryDetail";
import { debounce } from "lodash";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import ApprovalButton from "../input/ApprovalButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import TkDeliveryApplyButton from "../input/TkDeliveryApplyButton";
import defineConf from "../../config/defineConf";
import TkDeliveryCancelButton from "../input/TkDeliveryCancelButton";
import TkDeliveryDocExcelFormDownloadButton from "../input/TkDeliveryDocExcelFormDownloadButton";

function MomSysDelivery() {

    const id = "MomSysShipment";

    const table = "MomSysShipment"

    const view = "TkVwDelivery";

    const [height, setHeight] = useState();

    const [api, setApi] = useState();

    const [grid, setGird] = useState();

    const [schema, setSchema] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const authProfile = useRecoilValue(authProfileState);

    const [onSelectMst, setOnSelectMst] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    const [approvalCtx, setApprovalCtx] = useState();

    const [ isDetailEmpty, setIsDetailEmpty ] = useState();

    const { t } = useTranslation();

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);
        handleResize();

        let mounted = true;

        (async () => {

            let schema = await getSchema(table);

            if ( mounted ) {

                setSchema(schema);

            }

        })();

        return ( () => {

            mounted = false;
            window.removeEventListener("resize", handleResize);

        } );

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])
                    } else {

                        setOnSelectMst([]);

                    };
                    
                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }), 10);
            }

        })()

    }, [grid]);

    useEffect(() => {

        let approvalCtx = {

            approvalTypeId: 22,
            tableName: table,
            statusColumn: "approved",
            schema: schema,
            onValidateApprovalItem: (item) => {

                if (item.createdBy !== authProfile.username) {

                    return [false, t("error.approvalRequesterNotMatch")];

                }

                return [true, ""];

            },
            makeRequestItemDescription: (item) => {

                return `${t("approvalRequestMsg.msg.delivery", { deliveryNo: item.shipmentNo })}`; // Use Translation on Production Code

            }

        };

        setApprovalCtx(approvalCtx);

    }, [schema]);

    const onInitialized = (grid) => {

        grid.selectionMode = 'Row';

        setGird(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    const onDetailEmpty = ( isEmpty ) => {

        setIsDetailEmpty ( isEmpty );

    }

    const makeItemName = (item) => {

        return `납품 번호 : ${item.shipmentNo}`;

    }

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <CreateRecordButton
                        id={id}
                        schema={schema}
                        refresh={api}
                        onSuccess={onSuccess}
                    />
                    <UpdateRecordButton
                        id={id}
                        schema={schema}
                        grid={grid}
                        refresh={api}
                        disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                        onSuccess={onSuccess}
                    />
                    <DeleteRecordButton
                        id={id}
                        schema={schema}
                        grid={grid}
                        refresh={api}
                        color="secondary"
                        disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                        onPartialFailure={onNotifyWarning}
                        makeItemName = {makeItemName}
                    />
                    <ApprovalButton
                        id={id}
                        grid={grid}
                        refresh={api}
                        approvalCtx={approvalCtx}
                        disabled={onSelectMst?.deliveryState !== defineConf.deliveryState.NOT_DELIVERY ? true : false || isEmpty || isDetailEmpty}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                    />

                    <TkDeliveryApplyButton
                        id={id}
                        schema={schema}
                        refresh={api}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                        onSelectMst = {onSelectMst}
                        disabled={onSelectMst?.approvalState === defineConf.approvalState.APPROVED && !(onSelectMst?.deliveryState) ? false : true || isEmpty}
                    />

                    <TkDeliveryCancelButton
                        id={id}
                        schema={schema}
                        grid={grid}
                        refresh={api}
                        color="secondary"
                        disabled={onSelectMst?.approvalState === defineConf.approvalState.APPROVED && !(onSelectMst?.deliveryState) ? false : true  || isEmpty}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                        onPartialFailure={onNotifyWarning}
                    />

                    <SaveToExcelButton
                        id={id}
                        grid={grid}
                        view={view}
                        color="primary"
                        disabled={isEmpty}
                    />
                    <TkDeliveryDocExcelFormDownloadButton
                        id={id}
                        deliveryMst={onSelectMst}
                        view={view}
                        color="primary"
                        disabled={ isEmpty || isDetailEmpty || !defineConf.approvalState.APPROVED }
                    />
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.5}>
                    <BasicCrudScreenType
                        id={id}
                        table={table}
                        view={view}
                        headerTitle={t("term.MomSysDelivery")}
                        onLoadData={onLoadData}
                        onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
                        onApiInitialized={onApiInitialized}
                        onInitialized={onInitialized}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement>
                    {
                        onSelectMst
                        ?
                        <MomSysDeliveryDetail
                            id="MomSysShipmentDetail"
                            onSelectMst={onSelectMst}
                            onDetailEmpty={onDetailEmpty}
                        />
                        :
                        <></>
                    }
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default MomSysDelivery;
